<template> 
    <form method="POST" :action="route" @submit="checkForm">     
        <input type="hidden" name="_token" :value="token">             
            <section class="row dashboardstyleshadowwithout" style="padding-top: 20px">
                <div class="col-11 justify-content-center dashboardstyle" style="padding-top:5px;">
                        <table class="table justify-content-center text-center table-borderless" style="margin:auto; padding-left:0px; padding-right: 0px;width:100%!important;">
                            <thead class="paragraphe" style="font-size: 11px; color: #3867D6;">
                                <tr>
                                    <th scope="col" style="width:;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Platforme</th>
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Contrat</th> 
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);"></th> 
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">ISIN</th> 
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Montant</th>
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Devise</th>
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Période</th>                        
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Date 1er versement</th>
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Supprimer</th>
                                    <th scope="col" style="width: ;  vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);"></th>
                                </tr>
                            </thead>
                            <tbody  class="text-center align-content-center" style="font-size: 7px!important; max-height: 600px;">        
                                <tr v-for="(raw, index) in form" :key="index">                         
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                        <select
                                            class="form-control" style="font-size: 11px!important;"
                                            :class="{ 'is-invalid' : errors[index] ? (errors[index].platform) : false}"
                                            v-model="raw.platform"
                                            @change="onPlatformChange(raw)"
                                            :disabled="raw.disabled">                                    
                                            <option value="" disabled>Platforme</option>
                                            <option v-for="platform in platforms" :key="platform.id" :value="platform.id">{{ platform.name }}</option> 
                                        </select> 
                                    </td>
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                        <select
                                            class="form-control" style="font-size: 11px!important;" 
                                            :class="{ 'is-invalid' : errors[index] ? (errors[index].contract) : false}"              
                                            v-model="raw.contract"
                                            @change="onContractChange(raw)"
                                            :disabled="raw.disabled">                                
                                            <option value="" disabled>Contrat</option>                             
                                            <option v-for="contract in raw.contracts" :key="contract.id" :value="contract.id">{{ contract.name }}</option> 
                                        </select>   
                                    </td> 
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">                    
                                        <input 
                                            type="hidden" style="font-size: 11px!important;"
                                            :name="'form[' + index + '][platform_contract]'" 
                                            v-model="raw.platform_contract" 
                                            :disabled="raw.disabled">    
                                    </td>
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                        <select
                                            class="form-control" style="font-size: 11px!important;"
                                            :class="{ 'is-invalid' : errors[index] ? (errors[index].isin) : false}"
                                            :name="'form[' + index + '][isin]'" 
                                            v-model="raw.isin"
                                            :disabled="raw.disabled">                                    
                                            <option value='' disabled>ISIN</option>
                                            <option v-for="isin in raw.isins" :key="isin.id" :value="isin.isin">{{ isin.name }}</option> 
                                        </select>  
                                    </td>
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">                            
                                        <input
                                            type="number"
                                            class="form-control" style="font-size: 11px!important;"
                                            :class="{ 'is-invalid' : errors[index] ? (errors[index].amount) : false}"
                                            min="0"
                                            step="0.01"
                                            :name="'form[' + index + '][amount]'" 
                                            v-model="raw.amount"
                                            :disabled="raw.disabled">                                             
                                    </td>
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                        <select
                                            class="form-control" style="font-size: 11px!important;"
                                            :class="{ 'is-invalid' : errors[index] ? (errors[index].currency) : false}"
                                            :name="'form[' + index + '][currency]'" 
                                            v-model="raw.currency"                                
                                            :disabled="raw.disabled">                                    
                                            <option value="" disabled>Devise</option>
                                            <option v-for="currency in currencies" :key="currency.id" :value="currency.id">{{ currency.code }}</option> 
                                        </select> 
                                    </td>
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                        <select
                                            class="form-control" style="font-size: 11px!important;"
                                            :class="{ 'is-invalid' : errors[index] ? (errors[index].period) : false}"
                                            :name="'form[' + index + '][period]'"               
                                            v-model="raw.period"
                                            :disabled="raw.disabled">    
                                            <option value="" disabled>Période</option>                             
                                            <option value="1">Mensuel</option> 
                                            <option value="3">Trimestriel</option> 
                                            <option value="6">Semestriel</option> 
                                            <option value="12">Annuel</option>                                 
                                        </select>   
                                    </td>  
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                        <input
                                            type="date"
                                            class="form-control" style="font-size: 11px!important;"
                                            :class="{ 'is-invalid' : errors[index] ? (errors[index].date) : false}"
                                            :name="'form[' + index + '][date]'" 
                                            v-model="raw.date"
                                            :disabled="raw.disabled">                           
                                    </td>
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                        <div class="form-check">
                                            <input                                    
                                                type="checkbox"
                                                class="form-check-input"                                 
                                                v-model="raw.delete"
                                                :disabled="!raw.disabled">  
                                        </div>     
                                        <input v-if="raw.delete" type="hidden" :name="'form[' + index + '][delete]'" v-model="raw.id">                    
                                    </td>  
                                    <td style="width:;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                        <button
                                            v-if="!raw.disabled"
                                            type="button"
                                            class="close"
                                            aria-label="Close"
                                            v-on:click="form.splice(form.indexOf(raw), 1)">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </td>     
                                </tr>           
                            </tbody>
                        </table>
                    </div>

            </section>
        <div class="container text-center p-5">
            <button type="button" class="btn btn-myfo" v-on:click="addRaw">Ajouter une ligne</button>            
            <button type="submit" class="btn btn-myfo">Enregistrer</button>              
        </div> 
    </form>   
</template>

<script>
    export default {
        props: [
            'platforms_contracts',
            'currencies',
            'periodicities',
            'route',            
            'token'
        ],

        data() {
            return {                         
                platforms : [],       
                form: [],
                errors: []
            }           
        },
       
        mounted() {                    
            this.platforms_contracts.forEach(platform_contract => {
                if (!this.platforms.find(element => element.id == platform_contract.platform.id))
                {                    
                    this.platforms.push(platform_contract.platform);
                }   
            }); 

            this.periodicities.forEach(periodicity =>
            {                
                var raw = this.createRaw(true);
                raw.id = periodicity.id.toString();
                raw.platform = periodicity.platform_contract.platform.id.toString();
                this.onPlatformChange(raw);
                raw.contract = periodicity.platform_contract.contract.id.toString();
                this.onContractChange(raw);
                raw.isin = periodicity.isin.toString();
                raw.amount = periodicity.amount.toString();
                raw.currency = periodicity.currency.id.toString();
                raw.period = periodicity.period.toString();
                raw.date = periodicity.date.toString();    
            
                this.form.push(raw);
            });          
        },

        methods: {  
            
            createRaw(disabled){
                return  {
                        disabled: disabled,
                        id: null,
                        platform: '',
                        contracts:[],
                        contract: '',                        
                        platform_contract: '',  
                        isins: [],
                        isin: '',
                        amount: 0,
                        currency: '',
                        period: '',
                        date: '',
                        delete: null,
                    }
            },

            onPlatformChange(raw) {
                raw.contract = '';
                raw.type = '';
                raw.isin = '';

                raw.contracts = [];
                this.platforms_contracts.forEach(platform_contract => {
                    if (raw.platform == platform_contract.platform.id)
                    {
                        raw.contracts.push(platform_contract.contract);
                    }             
                });                
            },
                        
            onContractChange(raw) {
                raw.type = '';
                raw.isin = '';
                
                raw.isins = [];
                this.platforms_contracts.forEach(platform_contract => {
                    if (raw.platform == platform_contract.platform.id && raw.contract == platform_contract.contract.id)
                    {
                        raw.platform_contract = platform_contract.id;
                        raw.isins = platform_contract.isin_cash;
                    }             
                });                
            },

          

            addRaw() {
                this.form.push(this.createRaw(false))
            },          

            checkForm(event) {  
                var ok = true   
           
                this.errors = []         
                this.form.forEach(investment => {
                        this.errors.push({
                            platform: !investment.platform,
                            contract: !investment.contract,                            
                            isin: !investment.isin,                            
                            amount: investment.amount == 0,
                            currency: !investment.currency,
                            period: !investment.period,
                            date: !investment.date === '',                   
                        })
                        var inv = this.errors[this.errors.length - 1]
                        ok = !(!ok || inv.platform || inv.contract || inv.isin || inv.amount || inv.currency || inv.period || inv.date)
                    }
                )    

                if (!ok)
                {
                    event.preventDefault() 
                }
            }
        }        
    }
</script>
